import { SharedIcon } from "../shared/shared-icon";

export const ActivityHubAvatar = ({ isLiked, imgUrl }) => {
  return (
    <div className="activity-feed-group-item__user-avatar-wrapper">
      <img
        src={imgUrl}
        alt="User avatar"
        className="activity-feed-group-item__user-avatar"
      />
      {isLiked && (
        <div className="activity-feed-group-item__like-bullet">
          <SharedIcon
            iconName="#sprite-heart-full"
            className="activity-feed-group-item__like-icon"
          />
        </div>
      )}
    </div>
  );
};
